import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		background: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		padding: THEME.spacing.lg,
		boxShadow: `0 1px 3px ${THEME.colors.border.main}`,
		gridColumn: 'span 12 !important',
		// Recharts colors legend text with the series color inline (hence !important); the light series is unreadable.
		...CssSelectors.allDescendants(
			{ color: `${THEME.colors.text.main} !important`, fontSize: THEME.typography.fontSizes.xs },
			'.recharts-legend-item-text'
		),
	},
	header: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'baseline',
		columnGap: `${SPACE[16]}px`,
	},
	legend: {
		marginLeft: 'auto',
	},
	title: {
		fontSize: 18,
		fontWeight: 600,
		marginBottom: THEME.spacing.md,
		color: THEME.colors.text.main,
	},
	titleWithSubtitle: {
		marginBottom: SPACE[4],
	},
	subtitle: {
		margin: 0,
		marginBottom: SPACE[16],
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	loading: {
		padding: THEME.spacing.xl,
		textAlign: 'center',
		color: THEME.colors.text.light,
	},
	empty: {
		padding: THEME.spacing.xl,
		textAlign: 'center',
		color: THEME.colors.text.light,
	},
	tooltip: {
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: 4,
		padding: THEME.spacing.sm,
		boxShadow: `0 2px 8px rgba(0, 0, 0, 0.15)`,
	},
	tooltipLabel: {
		fontWeight: 600,
		marginBottom: THEME.spacing.xs,
		color: THEME.colors.text.main,
		fontSize: 14,
	},
	tooltipValue: {
		margin: 0,
		color: THEME.colors.text.light,
		fontSize: 12,
	},
});
